import React from "react";

const GuarantorDetails = ({
  id_R,
  closeGuarantorDetailsOpen,
  isGuarantorDetailsOpen,
  openRemoveGuarantor,
  openOverrideGuarantor,
  selectedGuarantor,
  formattedDate,
}) => {
  return (
    <>
      <div
        id={id_R}
        className={`${
          isGuarantorDetailsOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow max-w-[100%] mx-auto h-[95vh]">
            <div className="justify-end rounded-t flex items-end">
              <button
                onClick={closeGuarantorDetailsOpen}
                type="button"
                className="bg-transparent rounded-lg text-sm p-2.5 ml-auto inline-flex items-center"
                data-modal-toggle={id_R}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.84 12L5.7 8.9L3.9 12H0.2L3.88 6.3L0.1 0.839999H3.94L6.08 3.92L7.88 0.839999H11.58L7.84 6.46L11.68 12H7.84Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>
            <div className="flex items-center w-[58vw]">
              <div className="w-[10vw] flex items-center justify-center">
                <div className="w-[97px] h-[97px] rounded-full bg-[#7FB8EB] flex items-center justify-center text-[#06B217] text-[36px] font-medium">
                  {selectedGuarantor?.name
                    ?.split(" ")
                    ?.filter((word) => word.length > 0)
                    ?.map((word) => word[0])
                    ?.filter(
                      (_, index, arr) =>
                        index === 0 || index === arr.length - 1,
                    )
                    ?.join("")}
                </div>
              </div>
              <div className="w-[30vw]">
                <p className="text-[#000] text-[20px] bold">
                  {selectedGuarantor?.name
                    .split(" ")
                    .map(
                      (nam) =>
                        nam?.charAt(0)?.toUpperCase() +
                        nam?.slice(1)?.toLowerCase(),
                    )
                    .join(" ")}
                </p>
                <div className="w-[45vw] flex">
                  <div className="gap-2 w-[10vw]">
                    <p className="text-[#06B217] text-[15px] font-normal">
                      #{selectedGuarantor?.memberID}
                    </p>
                  </div>
                </div>

                <div className="mt-1.5 w-[25vw] flex">
                  <div
                    onClick={openRemoveGuarantor}
                    className="flex items-center gap-2 w-[20vw] cursor-pointer"
                  >
                    <img
                      src="/remove_guarantor.png"
                      alt="remove guarantor"
                      className=""
                    />
                    <p className="text-[#06B217] text-[14px] font-normal">
                      Remove As Guarantor
                    </p>
                  </div>
                  <div
                    onClick={openOverrideGuarantor}
                    className="flex items-center justify-center gap-2 w-[20vw] cursor-pointer"
                  >
                    <img
                      src="/overrideStatus.png"
                      alt="Override Status"
                      className=""
                    />
                    <p className="text-[#06B217] text-[14px] font-normal">
                      Override status
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-[95%] mx-[20px] h-[15vh] flex items-end ">
              <div className="w-[30vw]">
                <p className="text-[#000] text-[16px] font-medium">Email</p>
                <p className="mt-1.5 text-[#4F4F4F] text-[15px] font-[300] cursor-pointer">
                  {selectedGuarantor?.memberEmail}
                </p>
              </div>
              <div className="w-[20vw]">
                <p className="text-[#000] text-[16px] font-medium">
                  Phone Number
                </p>
                <p className="mt-1.5 text-[#4F4F4F] text-[15px] font-[300]">
                  {selectedGuarantor?.phoneNumber}
                </p>
              </div>
            </div>

            <div>
              <div className="mt-12 w-[95%] mx-[20px] h-[15vh] flex items-start">
                <div className="w-[30vw]">
                  <p className="text-[#000000] text-[16px] font-[500]">
                    Guarantorship Status
                  </p>
                  <div className="flex items-center gap-[5px] mt-1.5">
                    <p className="text-[#4F4F4F] text-[15px] font-[400]">
                      {selectedGuarantor?.status
                        ? selectedGuarantor?.status?.charAt(0)?.toUpperCase() +
                          selectedGuarantor?.status?.slice(1)?.toLowerCase()
                        : "No Status"}
                      {"   "}
                      Date:{"   "}
                      {formattedDate(selectedGuarantor?.dateRequested) ||
                        "Guarantor hasn't responded"}
                    </p>
                  </div>

                  <p
                    onClick={openOverrideGuarantor}
                    className="mt-1.5 text-[#06B217] text-[15px] font-normal cursor-pointer"
                  >
                    Override status
                  </p>
                </div>
                <div className="w-[20vw]">
                  <p className="text-[#000] text-[16px] font-medium">
                    Guaranteed Amount
                  </p>
                  <p className="mt-1.5 text-[#4F4F4F] text-[15px] font-[400]">
                    KES{" "}
                    {Number(
                      selectedGuarantor?.amountGuaranteed || "0.00",
                    )?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </div>
              </div>

              <div className="w-[95%] mx-[20px] h-[12vh] flex items-end ">
                <div className="w-[30vw]">
                  <p className="text-[#000] text-[16px] font-medium">
                    Savings Balance
                  </p>
                  <p className="mt-1.5 text-[#4F4F4F] text-[15px] font-[300] cursor-pointer">
                    KES &nbsp;
                    {Number(
                      selectedGuarantor?.savingsBalance || "0.00",
                    )?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </div>
                <div className="w-[20vw]">
                  <p className="text-[#000] text-[16px] font-medium">
                    Shares Balance
                  </p>
                  <p className="mt-1.5 text-[#4F4F4F] text-[15px] font-[300]">
                    KES &nbsp;
                    {Number(
                      selectedGuarantor?.sharesBalance || "0.00",
                    )?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </div>
              </div>

              <div className="w-[95%] h-[15vh] mx-[20px] flex items-end">
                <div className="w-[30vw]">
                  <p className="text-[#000] text-[15px] font-medium">
                    Balance Held
                  </p>
                  <p className="text-[#4F4F4F] text-[16px] font-[300]">
                    KES &nbsp;
                    {Number(
                      selectedGuarantor?.currentPrincipalHeld || "0.00",
                    )?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </div>
              </div>

              {/* <div className="w-[95%] h-[15vh] mx-[20px] flex items-end">
                <div className="w-[30vw]">
                  <p className="text-[#000] text-[15px] font-medium">
                    Loan Balance
                  </p>
                  <p className="text-[#4F4F4F] text-[16px] font-[300]">
                    {selectedGuarantor?.dateResponded || "Null"}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuarantorDetails;
